
export const SubtitleReducer = (state, action) =>{
    switch (action.type) {


        case "SET_isPlayerStart":
            return {
                ...state,
                isPlayerStart: action.payload
            };

        case "SET_handleDragValue":
            return {
                ...state,
                 handleDragValue: action.payload
            };
        case "SET_blue_row":
            return {
                ...state,
                blue_row: action.payload
            };

        case "SET_SubtitleData":
            return {
                ...state,
                SubtitleData: action.payload
            };
        case "SET_CtrlZ":
            return {
                ...state,
                CtrlZ: action.payload
            };

        case "SET_way":
            return {
                ...state,
                way: action.payload
            };
        case "SET_subTitle":
            return {
                ...state,
                subTitle: action.payload
            };

        case "SET_DragData":
            return {
                ...state,
                DragData: action.payload
            };

        case "SET_findFrameSplitValue":
            return {
                ...state,
                findFrameSplitValue: action.payload
            };
        case "SET_fFrameSplit":
            return {
                ...state,
                fFrameSplit: action.payload
            };


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/SubtitleReducer.js